import productNameRemapping from '../lib/productNameRemapping.json';

export const remapProductName = (productName: string): string => {
  const remappedName =
    productNameRemapping[productName as keyof typeof productNameRemapping] ||
    productName;
  return remappedName;
};
